"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const omitBy_1 = __importDefault(require("lodash/omitBy"));
function normalizeRequestContext(ctx) {
    return (0, omitBy_1.default)(
    // Note: It needs to be alphabetical for proper cache-key
    {
        agency: ctx.agency,
        b2bMarkup: ctx.b2bMarkup,
        bd4TravelUserId: ctx.bd4TravelUserId,
        device: ctx.device,
        language: ctx.language,
        partner: ctx.partner,
    }, value => (typeof value === 'number' && isNaN(value)) ||
        value === null ||
        typeof value === 'undefined');
}
exports.default = normalizeRequestContext;
//# sourceMappingURL=normalizeRequestContext.js.map